import React, { useEffect, useState } from "react"
import * as styles from "./header.module.scss"
import { HeaderMenuFieldsFragment } from "../../../../graphql-types"
import { useStaticQuery, graphql } from "gatsby"
import { HeaderQuery } from "../../../../graphql-types"
import useWindowWidth from "../../../hooks/use-window-width"
import { Turn as Hamburger } from "hamburger-react"
import SideMenu from "./side-menu/side-menu"
import DropdownNavbar, {
  KEY_CODES,
} from "./dropdown-menu-bar/dropdown-menu-bar"
import * as config from "../../../../config.js"

type RenderProps = {
  menuData: HeaderMenuFieldsFragment
}

const Header: React.FC<RenderProps> = ({ menuData }) => {
  const MOBILE: number = 1000
  const width = useWindowWidth()
  const isMobile = width <= MOBILE
  const [isOpen, setOpen] = useState(false)

  const data: HeaderQuery = useStaticQuery(graphql`
    query Header {
      datoCmsGlobalConfiguration {
        primaryColor {
          hex
        }
        subsidiaryLogo {
          url
          alt
          width
          height
        }
      }
    }
  `)

  function closeMenu() {
    setOpen(false)
  }

  const handleKeyEvents = event => {
    if (event.keyCode === KEY_CODES.SPACE) {
      event.preventDefault()
      event.stopPropagation()
      setOpen(!isOpen)
    }
  }

  useEffect(() => {
    if (document) {
      myFunction()
    }
  }, [isOpen])

  function myFunction() {
    if (
      document.getElementsByClassName("hamburger-react") &&
      document.getElementsByClassName("hamburger-react")[0]
    ) {
      document
        .getElementsByClassName("hamburger-react")[0]
        .setAttribute("aria-expanded", isOpen.toString())
    }
  }

  return (
    <div className={styles.globalHeader}>
      <div className={styles.header}>
        {isMobile && (
          <nav role="navigation" onKeyDown={event => handleKeyEvents(event)}>
            {/*https://github.com/luukdv/hamburger-react/issues/46*/}
            <Hamburger
              label="Menu"
              hideOutline={false}
              color={data.datoCmsGlobalConfiguration.primaryColor.hex}
              size={40}
              toggled={isOpen}
              toggle={setOpen}
              distance="md"
              aria-expanded={isOpen}
              rounded
            />
          </nav>
        )}
        <a href="/" className={styles.subsidiaryLogo}>
          <img
            src={data.datoCmsGlobalConfiguration.subsidiaryLogo.url}
            alt={config.back_to_home_title[config.locale]}
            width={data.datoCmsGlobalConfiguration.subsidiaryLogo.width}
            height={data.datoCmsGlobalConfiguration.subsidiaryLogo.height}
          />
        </a>
        {isMobile ? (
          <SideMenu
            isOpen={isOpen}
            closeMenu={closeMenu}
            headerMenu={menuData}
          />
        ) : (
          <DropdownNavbar headerMenu={menuData}></DropdownNavbar>
        )}
      </div>
    </div>
  )
}

export const queryFragments = graphql`
  fragment HeaderMenuFields on DatoCmsMenu {
    id
    label
    headerDisplay1
    menuBypassLink
    mainContentBypassLink
    externalPage
    page {
      slug
    }
    column1 {
      id
      label
      headerDisplay
      externalPage
      page {
        slug
      }
    }
    label2
    headerDisplay2
    externalPage2
    page2 {
      slug
    }
    column2 {
      id
      label
      headerDisplay
      externalPage
      page {
        slug
      }
    }
    label3
    headerDisplay3
    externalPage3
    page3 {
      slug
    }
    column3 {
      id
      label
      headerDisplay
      externalPage
      page {
        slug
      }
    }
    label4
    headerDisplay4
    externalPage4
    page4 {
      slug
    }
    column4 {
      id
      label
      headerDisplay
      externalPage
      page {
        slug
      }
    }
    label5
    headerDisplay5
    externalPage5
    page5 {
      slug
    }
    column5 {
      id
      label
      headerDisplay
      externalPage
      page {
        slug
      }
    }
  }
`

export default Header
